if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }
// ✅ Funkcia na sledovanie chýb a inteligentný refresh stránky
setupErrorObserver() {
    window.onerror = (message, source, lineno, colno, error) => {
        if (message && message.includes("Maximum call stack size exceeded")) {
            console.error("🚨 Detegovaná chyba Maximum Call Stack Size Exceeded!");
            
            // Použijeme sessionStorage na sledovanie počtu výskytov
            let errorCount = sessionStorage.getItem('stackErrorCount') || 0;
            errorCount++;

            sessionStorage.setItem('stackErrorCount', errorCount);
            console.warn(`⚠️ Počet výskytov chyby: ${errorCount}`);

            // ✅ Refresh stránku iba ak sa táto chyba vyskytne 3-krát po sebe
            if (errorCount >= 3) {
                console.error("🔄 Príliš veľa chýb! Reloadujeme stránku...");
                sessionStorage.removeItem('stackErrorCount'); // Reset counter
                setTimeout(() => {
                    window.location.reload();
                }, 1500); // Dáme 1.5 sekundy pred reloadom
            }
        }
    };
}

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

document.addEventListener("DOMContentLoaded", function () {
    function initQuantityControls() {
        let quantityInput = document.querySelector('input.quantity__input');
        let plusButton = document.querySelector('button[name="plus"]');
        let minusButton = document.querySelector('button[name="minus"]');

        if (!quantityInput || !plusButton || !minusButton) {
            console.error("❌ Nenájdené prvky: quantityInput / plusButton / minusButton");
            return;
        }

        let maxStock = document.querySelector('.inventory-data')?.dataset.stock || 99;
        let min = parseInt(quantityInput.getAttribute("min"), 10) || 1;
        let max = parseInt(maxStock, 10);

        // Zakázanie priameho zadávania do inputu + vizuálne úpravy
        quantityInput.setAttribute('readonly', true);
        quantityInput.setAttribute('tabindex', '-1'); // Zabráni fokusu cez klávesnicu
        quantityInput.style.pointerEvents = 'none'; // Zakáže klikateľnosť
        quantityInput.style.background = 'transparent'; // Odstráni vizuálny efekt vstupu
        quantityInput.style.cursor = 'default'; // Zmení kurzor na neinteraktívny
        quantityInput.style.border = 'none'; // Odstráni orámovanie
        quantityInput.style.outline = 'none'; // Odstráni možnosť zamerania

        console.log(`🔍 Min: ${min}, Max: ${max}`);

        // Pridanie alebo nájdenie error divu
        let errorDiv = document.querySelector('.quantity-error');
        if (!errorDiv) {
            errorDiv = document.createElement("div");
            errorDiv.classList.add("quantity-error");
            quantityInput.closest('.product-form__quantity').appendChild(errorDiv);
        }

        // Nastavenie CSS pre error hlásenie
        errorDiv.style.color = "red";
        errorDiv.style.fontSize = "15px";
        errorDiv.style.marginTop = "15px";
        errorDiv.style.padding = "5px";
        errorDiv.style.display = "none";
        errorDiv.style.textAlign = "center";

        function getStockMessage(stock) {
            if (stock === 1) return `Momentálne nemáme na sklade viac ako 1 kus.`;
            if (stock >= 2 && stock <= 4) return `Momentálne nemáme na sklade viac ako ${stock} kusy.`;
            return `Momentálne nemáme na sklade viac ako ${stock} kusov.`;
        }

        // Odstránime existujúcich event listenerov
        plusButton.replaceWith(plusButton.cloneNode(true));
        minusButton.replaceWith(minusButton.cloneNode(true));

        plusButton = document.querySelector('button[name="plus"]');
        minusButton = document.querySelector('button[name="minus"]');

        // Kliknutie na PLUS
        plusButton.addEventListener("click", function () {
            let currentValue = parseInt(quantityInput.value, 10) || min;
            if (currentValue < max) {
                quantityInput.value = currentValue + 1;
                quantityInput.dispatchEvent(new Event('change'));
                errorDiv.style.display = "none";
            } else {
                errorDiv.textContent = getStockMessage(max);
                errorDiv.style.display = "block";
            }
        });

        // Kliknutie na MINUS
        minusButton.addEventListener("click", function () {
            let currentValue = parseInt(quantityInput.value, 10) || min;
            if (currentValue > min) {
                quantityInput.value = currentValue - 1;
                quantityInput.dispatchEvent(new Event('change'));
                errorDiv.style.display = "none";
            }
        });

        console.log("✅ Event listenery boli úspešne pridané.");
    }

    initQuantityControls();

    setInterval(() => {
        let quantityInput = document.querySelector('input.quantity__input');
        if (quantityInput && !quantityInput.hasAttribute('data-listeners')) {
            initQuantityControls();
            quantityInput.setAttribute('data-listeners', 'true');
        }
    }, 2000);
});












